import {
  PIXABAY_API_BASE_URL,
  PIXABAY_ACCESS_KEY,
} from "../constants/imageServices";
import { fetch } from "./base";

export const fetchPixabayPhotos = async (
  search = "nature",
  page = 1,
  orientation = "landscape"
) => {
  return fetch(
    `${PIXABAY_API_BASE_URL}?key=${PIXABAY_ACCESS_KEY}&q=${search}&page=${page}&per_page=50&orientation=${orientation}`,
    { cache: true, thirdParty: true }
  );
};

export const fetchPixabayVideo = async (collectionName) => {
  return fetch(
    `${PIXABAY_API_BASE_URL}videos/?key=${PIXABAY_ACCESS_KEY}&q=${collectionName}&page=1&per_page=50&orientation=landscape`,
    { cache: true, thirdParty: true }
  );
};
